import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', {
    state: () => {
        return { foo: 'bar' }
    },
})

export const useCounterStore = defineStore('counter', () => {
    const versionNumber = ref("3.0.0")
    const activeTab = ref('home')

    return {  versionNumber, activeTab }
})
